var map = {
	"./weapon1.png": "8928",
	"./weapon10.png": "e16b",
	"./weapon11.png": "3d97",
	"./weapon12.png": "c4d9",
	"./weapon13.png": "ff8f",
	"./weapon14.png": "4a84",
	"./weapon15.png": "b109",
	"./weapon2.png": "3957",
	"./weapon3.png": "92b4",
	"./weapon4.png": "3288",
	"./weapon5.png": "8f1f",
	"./weapon6.png": "b717",
	"./weapon7.png": "5ca8",
	"./weapon8.png": "3aea",
	"./weapon9.png": "4d9b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a92d";